import { render, staticRenderFns } from "./CreatePostSchedule.vue?vue&type=template&id=12116bfa&"
import script from "./CreatePostSchedule.vue?vue&type=script&lang=js&"
export * from "./CreatePostSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports